// components/widgets/primitives/pill-row.js
// ═══════════════════════════════════════════════════════════
// PILL ROW — DI-style key | value status row.
// e.g.  "Trend Direction         Trending"
//        "Volatility Regime       Normal · VIX 19.39"
//
// Group multiple PillRows inside a PillTable for the bordered
// list look (used for thesis stress test, force tracker, etc.).
// ═══════════════════════════════════════════════════════════

const VALID_TONES = ['sage', 'steel', 'amber', 'terra', 'gold', 'teal', 'sand', 'purple'];

export function PillTable({ children, className = '' }) {
  return <div className={`ws-prim-pills ${className}`}>{children}</div>;
}

export default function PillRow({
  keyText,
  valueText,
  tone = 'steel',
  className = '',
  children,
}) {
  const safeTone = VALID_TONES.includes(tone) ? tone : 'steel';
  return (
    <div className={`ws-prim-pill-row ${className}`}>
      <span className="ws-prim-pill-key">{keyText}</span>
      <span className={`ws-prim-pill-value ws-prim-pill-value-${safeTone}`}>
        {children || valueText}
      </span>
    </div>
  );
}
